import React, { useCallback } from "react";
import { useTheme } from "@mui/material";
import ErrorRounded from "@mui/icons-material/ErrorRounded";
import StatusScreen from "./StatusScreen";

const CheckoutFailed = () => {
    const theme = useTheme();

    const onContactSupport = useCallback(() => {
        window.location.href = "mailto:support@bizapptor.com";
    }, []);

    return (
        <StatusScreen
            icon={ErrorRounded}
            iconColor={theme.palette.error.main}
            title="Payment Failed"
            subtitle="Your payment could not be completed. Please try again or contact our support team."
            description="We're here to help — reach out and we'll sort it out for you."
            buttonLabel="Try Again"
            onButtonClick={() => (window.location.href = "/menu/subscriptions")}
            secondaryButtonLabel="Contact Support"
            onSecondaryClick={onContactSupport}
        />
    );
};

export default CheckoutFailed;
